import { useEffect, useState } from "react";
import AdminLayout from "../../components/admin/AdminLayout";
import { api } from "../../lib/api";

const initialForm = { title: "", category: "General", priority: "normal", target_audience: "all", status: "published", body: "" };

export default function NoticesManager() {
  const [notices, setNotices] = useState([]);
  const [form, setForm] = useState(initialForm);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  async function load() {
    const data = await api("/api/admin/notices");
    setNotices(data);
  }

  useEffect(() => {
    load().catch((err) => setError(err.message));
  }, []);

  async function submit(e) {
    e.preventDefault();
    setError("");
    setMessage("");
    try {
      await api("/api/admin/notices", { method: "POST", body: JSON.stringify(form) });
      setForm(initialForm);
      setMessage("Notice created successfully.");
      await load();
    } catch (err) {
      setError(err.message);
    }
  }

  async function remove(id) {
    if (!window.confirm("Delete this notice?")) return;
    await api(`/api/admin/notices/${id}`, { method: "DELETE" });
    await load();
  }

  return (
    <AdminLayout title="Manage Notices">
      {message && <div className="mb-4 rounded-xl bg-emerald-50 p-4 font-semibold text-emerald-700">{message}</div>}
      {error && <div className="mb-4 rounded-xl bg-red-50 p-4 font-semibold text-red-700">{error}</div>}

      <div className="grid gap-6 lg:grid-cols-3">
        <form onSubmit={submit} className="rounded-3xl bg-white p-6 shadow-sm ring-1 ring-slate-200 lg:col-span-1">
          <h2 className="text-lg font-bold text-slate-900">Create Notice</h2>
          <div className="mt-4 space-y-3">
            <input className="w-full rounded-xl border p-3" placeholder="Notice title" value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} required />
            <input className="w-full rounded-xl border p-3" placeholder="Category" value={form.category} onChange={(e) => setForm({ ...form, category: e.target.value })} required />
            <select className="w-full rounded-xl border p-3" value={form.priority} onChange={(e) => setForm({ ...form, priority: e.target.value })}>
              <option value="normal">Normal</option>
              <option value="important">Important</option>
              <option value="urgent">Urgent</option>
            </select>
            <select className="w-full rounded-xl border p-3" value={form.target_audience} onChange={(e) => setForm({ ...form, target_audience: e.target.value })}>
              <option value="all">All</option>
              <option value="students">Students</option>
              <option value="staff">Staff</option>
              <option value="applicants">Applicants</option>
            </select>
            <select className="w-full rounded-xl border p-3" value={form.status} onChange={(e) => setForm({ ...form, status: e.target.value })}>
              <option value="published">Published</option>
              <option value="draft">Draft</option>
              <option value="archived">Archived</option>
            </select>
            <textarea className="min-h-40 w-full rounded-xl border p-3" placeholder="Notice body" value={form.body} onChange={(e) => setForm({ ...form, body: e.target.value })} required />
            <button className="w-full rounded-xl bg-emerald-700 px-4 py-3 font-bold text-white">Publish Notice</button>
          </div>
        </form>

        <div className="rounded-3xl bg-white p-6 shadow-sm ring-1 ring-slate-200 lg:col-span-2">
          <h2 className="text-lg font-bold text-slate-900">All Notices</h2>
          <div className="mt-4 space-y-3">
            {notices.map((notice) => (
              <div key={notice.id} className="rounded-2xl border border-slate-200 p-4">
                <div className="flex flex-wrap items-start justify-between gap-3">
                  <div>
                    <h3 className="font-bold text-slate-900">{notice.title}</h3>
                    <p className="text-sm text-slate-500">{notice.category} • {notice.priority} • {notice.status}</p>
                  </div>
                  <button onClick={() => remove(notice.id)} className="rounded-lg bg-red-600 px-3 py-2 text-sm font-bold text-white">Delete</button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </AdminLayout>
  );
}
